import { createApp, reactive } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/style.css";
import "@splidejs/splide/css";
import VueSplide from "@splidejs/vue-splide";
import "@fontsource/kantumruy-pro";
import "@fontsource/kantumruy-pro/400.css";
import "@fontsource/kantumruy-pro/700.css";

const app = createApp(App);
app.use(VueSplide);

// Create a reactive state for the current language
const state = reactive({
  currentLang: localStorage.getItem("lang") || "en", // Default to 'en' if not set
});

// Function to update the font based on the selected language
function updateFont(currentLang) {
  const body = document.body;
  if (currentLang === "kh") {
    body.style.fontFamily = "'Kantumruy Pro', sans-serif"; // Khmer font
  } else {
    body.style.fontFamily = "'Roboto', sans-serif"; // Default font
  }
}

// Initialize font with the current language
updateFont(state.currentLang);

// Global method to change the language and update the font without reloading
app.config.globalProperties.changeLanguage = (newLang) => {
  state.currentLang = newLang; // Update the reactive state
  localStorage.setItem("lang", newLang); // Save the language in local storage
  updateFont(newLang); // Update the font
};

// Make the `state` reactive property globally accessible
app.provide("state", state);

app.use(router); // Use the router in your app
app.mount("#app"); // Mount the app to the DOM element with id "app"
